import type { MailDispatchPurpose } from '../types/mailDispatch.ts';

export type DispatchAccountResponse = {
  account_id: string | null;
  email: string | null;
  signature_html: string | null;
  used_fallback: boolean;
  configured_account_id: string | null;
  /** True when the user has at least one visible sendable mailbox (incl. own private). */
  can_choose: boolean;
};

export async function fetchDispatchAccount(purpose: MailDispatchPurpose): Promise<DispatchAccountResponse> {
  const res = await fetch(`/api/inbox/dispatch-account/${encodeURIComponent(purpose)}`, {
    credentials: 'include',
  });
  const data = (await res.json().catch(() => ({}))) as DispatchAccountResponse & { error?: string };
  if (!res.ok) {
    throw new Error(data.error || 'Absender-Konto konnte nicht geladen werden.');
  }
  return {
    account_id: data.account_id ?? null,
    email: data.email ?? null,
    signature_html: data.signature_html ?? null,
    used_fallback: Boolean(data.used_fallback),
    configured_account_id: data.configured_account_id ?? null,
    can_choose: Boolean(data.can_choose),
  };
}
